const nl = {
  a11yVideoLabelText: "Video die gezichtslevenscontrole toont",
  cameraMinSpecificationsHeadingText: "Minimale cameraspecificaties",
  cameraMinSpecificationsMessageText:
    "Zorg ervoor dat uw camera voldoet aan de minimale specificaties die vereist zijn voor de levenscontrole.",
  cameraNotFoundHeadingText: "Camera niet gevonden",
  cameraNotFoundMessageText:
    "We konden geen camera detecteren. Zorg ervoor dat uw camera is aangesloten en probeer het opnieuw.",
  cancelLivenessCheckText: "Levenscontrole annuleren",
  clientHeaderText: "Bericht van de klant",
  clientMessageText:
    "Volg de instructies op het scherm om de gezichtslevenscontrole te voltooien.",
  connectionTimeoutHeaderText: "Verbindingstime-out",
  connectionTimeoutMessageText:
    "De verbinding is verlopen. Controleer uw internetverbinding en probeer het opnieuw.",
  errorLabelText: "Fout",
  faceDistanceHeaderText: "Gezichtsafstand",
  faceDistanceMessageText:
    "Zorg ervoor dat uw gezicht op de juiste afstand van de camera is.",
  goodFitAltText: "Gezicht is goed uitgelijnd",
  goodFitCaptionText: "Uw gezicht is goed uitgelijnd. Blijf stil.",
  hintCanNotIdentifyText:
    "Kan gezicht niet identificeren. Probeer het opnieuw.",
  hintCenterFaceInstructionText: "Centreer uw gezicht in het frame.",
  hintCenterFaceText: "Centreer uw gezicht",
  hintCheckCompleteText: "Controle voltooid",
  hintConnectingText: "Verbinden...",
  hintFaceDetectedText: "Gezicht gedetecteerd",
  hintFaceOffCenterText: "Uw gezicht is niet gecentreerd. Pas aan.",
  hintHoldFaceForFreshnessText: "Houd uw gezicht stil voor de controle.",
  hintIlluminationNormalText: "Verlichting is goed",
  hintIlluminationTooBrightText: "Verlichting is te fel",
  hintIlluminationTooDarkText: "Verlichting is te donker",
  hintMatchIndicatorText: "Gezichtsindicatoren vergelijken...",
  hintMoveFaceFrontOfCameraText: "Beweeg uw gezicht voor de camera",
  hintTooCloseText: "U bent te dicht bij de camera",
  hintTooFarText: "U bent te ver van de camera",
  hintTooManyFacesText:
    "Er zijn te veel gezichten gedetecteerd. Er mag slechts één gezicht in het frame zijn.",
  hintVerifyingText: "Verifiëren...",
  landscapeHeaderText: "Landschapsmodus gedetecteerd",
  landscapeMessageText:
    "Schakel over naar de portretmodus voor de levenscontrole.",
  multipleFacesHeaderText: "Meerdere gezichten gedetecteerd",
  multipleFacesMessageText:
    "Er mag slechts één gezicht in het frame zijn. Pas aan en probeer het opnieuw.",
  photosensitivityWarningBodyText:
    "Deze controle omvat een reeks visuele stimuli. Als u problemen heeft met lichtgevoeligheid, ga dan voorzichtig verder.",
  photosensitivityWarningHeadingText: "Waarschuwing voor lichtgevoeligheid",
  photosensitivityWarningInfoText:
    "U kunt de controle op elk moment stoppen als u zich ongemakkelijk voelt.",
  photosensitivityWarningLabelText: "Ik begrijp de risico's",
  portraitMessageText: "Houd uw apparaat in de portretmodus.",
  recordingIndicatorText: "Opname bezig",
  retryCameraPermissionsText: "Cameratoestemmingen opnieuw proberen",
  serverHeaderText: "Serverprobleem",
  serverMessageText:
    "Er was een probleem met het verbinden met de server. Probeer het later opnieuw.",
  startScreenBeginCheckText: "Begin levenscontrole",
  timeoutHeaderText: "Tijd overschreden",
  timeoutMessageText: "Het proces is verlopen. Probeer het opnieuw.",
  tooFarAltText: "Gezicht is te ver van de camera",
  tooFarCaptionText: "Beweeg dichter naar de camera.",
  tryAgainText: "Probeer opnieuw",
  waitingCameraPermissionText: "Wachten op cameratoestemming...",
};

export default nl;
